import { v4 as uuid } from 'uuid';

import { LinkCategory } from 'src/containers/ProjectDiagram/constants/categories';
import {
  MappingIdentifier,
  RelationshipMapping,
} from 'src/containers/ProjectDiagram/types/data';

export type CreateRelationshipMappingOptions =
  | {
      from?: never;
      fromClassIri: string;
      fromPrimaryIdentifier: MappingIdentifier;

      to: string;
      toClassIri?: never;
      toPrimaryIdentifier?: never;

      relationshipIri: string;
      value?: string;
    }
  | {
      from: string;
      fromClassIri?: never;
      fromPrimaryIdentifier?: never;

      to?: never;
      toClassIri: string;
      toPrimaryIdentifier: MappingIdentifier;

      relationshipIri: string;
      value?: string;
    };

export const getRelationshipMappingKey = (value: string) =>
  `${LinkCategory.RELATIONSHIP_MAPPING}-${value}`;

export const createRelationshipMapping = ({
  from,
  fromClassIri,
  fromPrimaryIdentifier,
  relationshipIri,
  to,
  toClassIri,
  toPrimaryIdentifier,
  value = uuid(),
}: CreateRelationshipMappingOptions): RelationshipMapping =>
  ({
    category: LinkCategory.RELATIONSHIP_MAPPING,
    from,
    fromClassIri,
    fromPrimaryIdentifier,
    key: getRelationshipMappingKey(value),
    // this is to appease GoJS, which uses the default link template
    // since no template is provided for relationship mappings,
    // and tries to iterate over labelKeys
    labelKeys: [],
    relationshipIri,
    to,
    toClassIri,
    toPrimaryIdentifier,
    value,
  } as RelationshipMapping);
